import { cx } from '@/lib/utils';

const ActivityIndicator = ({
  size = 'default',
  className,
}: {
  size?: 'default' | 'large' | 'small';
  className?: string;
}) => {
  const segments = Array.from({ length: 8 }, (_, i) => i);

  const getDelayStyle = (index: number): React.CSSProperties => ({
    animationDelay: `${-1.625 + index * 0.125}s`,
  });

  const baseClasses =
    size === 'large'
      ? 'w-[35px] h-[35px]'
      : size === 'small'
        ? 'w-[15px] h-[15px]'
        : 'w-[20px] h-[20px]';

  const bladeClasses =
    size === 'large'
      ? 'w-[5px] h-[12px] top-[11.5px] left-[15px] rounded-[2.5px]'
      : size === 'small'
        ? 'w-[1.5px] h-[5px] top-[5px] left-[6.25px] rounded-[1.25px]'
        : 'w-[2.5px] h-[6.5px] top-[6.5px] left-[8.5px] rounded-[1.25px]';

  const translateY = size === 'large' ? '-11.5px' : '-6.5px';

  return (
    <div className={`relative ${baseClasses}`}>
      {segments.map((i) => (
        <div
          key={i}
          style={{
            transform: `rotate(${i * 45}deg) translateY(${translateY})`,
            ...getDelayStyle(i),
          }}
          className={cx(
            `absolute animate-spinner-blade bg-[#8e8e93] ${bladeClasses}`,
            className,
          )}
        />
      ))}
    </div>
  );
};

export default ActivityIndicator;
